module.exports = "https://bin.bnbstatic.com/_next/static/images/step1-632176151f93b4310eb3ed46ec24d5de.png";